import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';
import { prepareSearchParams } from '@/libs/helper';

const resource = `${Config.basePath}/v1/api/admin/zone`;

export default {
  index(payload) {
    let params = prepareSearchParams(payload);
    if (payload.search) {
      params.filters.push({
        searchby: "name",
        searchoperator: "=",
        search: payload.search.toUpperCase(),
      });
    }
    return Client.post(resource, {
      ...params
    }, {
      headers: {
        action: "zone-list",
      },
    });
  },
  create(payload) {
    const params = {
      ...payload,
    };
    return Client.post(resource, params, {
      headers: {
        action: "zone-store",
      },
    });
  },
  show(id, payload = {}) {
    const params = {
      ...payload,
      id: id,
    };
    return Client.post(resource, params, {
      headers: {
        action: "zone-show",
      },
    });
  },
  update(id, payload) {
    const params = {
      ...payload,
      id: id,
    };
    return Client.post(resource, params, {
      headers: {
        action: "zone-update",
      },
    });
  },
  options(payload) {
    return Client.post(resource, payload, {
      headers: {
        action: "list-option",
      },
    });
  },
};
